/* sp-product.js — ficha del producto del kit Shopify maker (CONTRACTS §K.3; PAR-16, PAR-24, PAR-75, PAR-77, PAR-122).
   Se carga con defer desde snippets/product-template.liquid sólo en el template product. Idempotente (flag global) y
   con delegación en document: sobrevive a los re-renders del editor de temas.
   (1) Galería lista para deslizar: tras load, en requestIdleCallback (timeout 3000; sin él, 1200 ms) pre-decodifica las
       .product-slideshow img ("descargada" no es "lista para pintar": sin esto el celular decodifica al deslizar).
   (2) Mobile: tocar .photoswipe__image hace click en el .js-photoswipe__zoom de la misma .image-wrap (la lupa va
       oculta por CSS en mobile) — sólo en la galería de la ficha ([data-sp-context="main"]).
   (3) Botón flotante [data-sp-sticky]: 2 IntersectionObserver (título con rootMargin 60px arriba; botón real con 25 %
       abajo), sin scroll listeners; texto desde data-label / data-label-n ([count]) y sp:bundle:change; click → click
       del button[name="add"] del form; --om-vv desde visualViewport (barra de Safari); oculto si el botón real está
       deshabilitado. Las animaciones son CSS (40-product.css respeta prefers-reduced-motion).
   (4) Stock por variante: en variant:change aplica el mapa [data-sp-stock-map] (available, bars, status) al
       [data-sp-stock] cuyo mapa tiene esa variante (los ids de variante son únicos).
   (5) Videos diferidos de la descripción (PAR-47 con product.media.descriptionVideoLoading lazy): video[data-sp-src]
       llega sin src ni autoplay (0 bytes en el load; width/height reservan el lugar). Un IntersectionObserver
       (rootMargin 200px) le pone el src, load() y play() una sola vez; con prefers-reduced-motion: reduce carga el
       primer cuadro (preload metadata) con controles y no reproduce; si el navegador frena el play(), quedan los
       controles. Sin IntersectionObserver carga enseguida. Sin listeners. También lo carga product-description.liquid
       fuera del template product (featured de la home con el bloque descripción). */
(function () {
  'use strict';
  if (window.__spProductInit) return;
  window.__spProductInit = true;

  function toArray(list) { return Array.prototype.slice.call(list || []); }

  // ---------------------------------------------------------------- (1) decode en idle

  function decodeGallery() {
    toArray(document.querySelectorAll('.product-slideshow img')).forEach(function (img) {
      if (typeof img.decode !== 'function') return;
      try { img.decode().catch(function () {}); } catch (e) { /* imagen sin src todavía */ }
    });
  }
  function whenIdle() {
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(decodeGallery, { timeout: 3000 });
    else setTimeout(decodeGallery, 1200);
  }
  if (document.readyState === 'complete') whenIdle();
  else window.addEventListener('load', whenIdle);

  // ---------------------------------------------------------------- (2) tocar la foto abre el zoom (mobile)

  var MOBILE = '(max-width: 768px)';
  document.addEventListener('click', function (e) {
    if (!window.matchMedia || !window.matchMedia(MOBILE).matches) return;
    var img = e.target && e.target.closest && e.target.closest('.photoswipe__image');
    if (!img || !img.closest('[data-sp-context="main"]')) return;
    var wrap = img.closest('.image-wrap');
    var zoom = wrap && wrap.querySelector('.js-photoswipe__zoom');
    if (!zoom) return;
    e.preventDefault();
    zoom.click();
  });

  // ---------------------------------------------------------------- (3) botón flotante

  function bundleQty(formId) {
    var list = toArray(document.querySelectorAll('[data-sp-bundle]'));
    for (var i = 0; i < list.length; i++) {
      if (formId && list[i].getAttribute('data-form-id') !== formId) continue;
      var radio = list[i].querySelector('input[name="om-bundle"]:checked');
      var n = radio ? parseInt(radio.value, 10) : 1;
      return n > 0 ? n : 1;
    }
    return 1;
  }

  function initSticky(wrap) {
    if (wrap.__spSticky) return;
    var formId = wrap.getAttribute('data-form-id') || '';
    var form = formId ? document.getElementById(formId) : null;
    var root = (form && form.closest('[data-section-type="product"]')) || document;
    var title = root.querySelector('.product-single__title');
    var real = (form && form.querySelector('button[name="add"]')) || root.querySelector('button[name="add"]');
    var btn = wrap.querySelector('.om-sticky-atc__btn');
    var label = wrap.querySelector('.om-sticky-atc__label');
    if (!title || !real || !btn || !label) return;
    wrap.__spSticky = true;

    var realVisible = false;
    var pastTitle = false;
    function refresh() {
      wrap.classList.toggle('is-visible', pastTitle && !realVisible && !real.disabled);
    }
    if ('IntersectionObserver' in window) {
      // el botón real "cuenta" como visible un poco antes de entrar: el flotante se retira sin parpadeos
      new IntersectionObserver(function (entries) {
        realVisible = entries[entries.length - 1].isIntersecting;
        refresh();
      }, { rootMargin: '0px 0px 25% 0px' }).observe(real);
      new IntersectionObserver(function (entries) {
        var en = entries[entries.length - 1];
        pastTitle = !en.isIntersecting && en.boundingClientRect.top < 0;
        refresh();
      }, { rootMargin: '60px 0px 0px 0px' }).observe(title);
    }
    btn.addEventListener('click', function () { real.click(); });

    function setLabel(n) {
      var one = wrap.getAttribute('data-label') || label.textContent;
      var many = wrap.getAttribute('data-label-n');
      label.textContent = n > 1 && many ? many.replace('[count]', String(n)) : one;
    }
    setLabel(bundleQty(formId));
    wrap.__spSetLabel = setLabel;
    wrap.__spRefresh = refresh;

    // iOS: la barra del navegador reaparece al scrollear hacia arriba y tapaba el botón
    var vv = window.visualViewport;
    if (vv) {
      var adjust = function () {
        var covered = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
        wrap.style.setProperty('--om-vv', Math.round(covered) + 'px');
      };
      vv.addEventListener('resize', adjust, { passive: true });
      vv.addEventListener('scroll', adjust, { passive: true });
      adjust();
    }
  }

  document.addEventListener('sp:bundle:change', function (e) {
    var d = e.detail || {};
    var n = parseInt(d.qty, 10) || 1;
    toArray(document.querySelectorAll('[data-sp-sticky]')).forEach(function (wrap) {
      if (d.formId && wrap.getAttribute('data-form-id') !== d.formId) return;
      if (wrap.__spSetLabel) wrap.__spSetLabel(n);
    });
  });

  // ---------------------------------------------------------------- (4) stock por variante

  function stockMap(ind) {
    if (ind.__spMap !== undefined) return ind.__spMap;
    var holder = ind.parentNode && ind.parentNode.querySelector('[data-sp-stock-map]');
    var map = null;
    if (holder) {
      try { map = JSON.parse(holder.textContent || '{}'); } catch (e) { map = null; }
    }
    ind.__spMap = map;
    return map;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function applyStock(ind, entry) {
    if (entry.available === false) { ind.hidden = true; return; }
    ind.hidden = false;
    var total = parseInt(ind.getAttribute('data-bars'), 10) || 4;
    var filled = Math.max(0, Math.min(total, parseInt(entry.bars, 10) || 0));
    var status = filled > 0 && entry.status ? String(entry.status) : 'none';
    ind.setAttribute('data-status', status);
    var parts = ind.querySelectorAll('.om-stock-sep, .om-stock-label, .om-stock-bars, .om-stock-status');
    if (status === 'none') {
      toArray(parts).forEach(function (p) { p.parentNode.removeChild(p); });
      return;
    }
    var bars = ind.querySelector('.om-stock-bars');
    if (!bars) {
      var sep = el('span', 'om-stock-sep', '|');
      sep.setAttribute('aria-hidden', 'true');
      bars = el('span', 'om-stock-bars');
      bars.setAttribute('aria-hidden', 'true');
      ind.appendChild(sep);
      ind.appendChild(el('span', 'om-stock-label', ind.getAttribute('data-label') || ''));
      ind.appendChild(bars);
      ind.appendChild(el('span', 'om-stock-status', ''));
    }
    while (bars.children.length < total) bars.appendChild(el('span', 'om-stock-bar'));
    toArray(bars.children).forEach(function (bar, i) { bar.classList.toggle('om-stock-bar--filled', i < filled); });
    var text = ind.querySelector('.om-stock-status');
    if (text) text.textContent = ind.getAttribute('data-status-' + status) || '';
  }

  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && v.id != null) {
      toArray(document.querySelectorAll('[data-sp-stock]')).forEach(function (ind) {
        var map = stockMap(ind);
        var entry = map && map[String(v.id)];
        if (entry) applyStock(ind, entry);
      });
    }
    // theme.js ya actualizó el botón real (disabled/agotado) en variantChange: el flotante lo sigue
    toArray(document.querySelectorAll('[data-sp-sticky]')).forEach(function (wrap) {
      if (wrap.__spRefresh) wrap.__spRefresh();
    });
  });

  // ---------------------------------------------------------------- (5) videos diferidos de la descripción

  var LAZY_VIDEO = 'video[data-sp-src]';
  var STILL = '(prefers-reduced-motion: reduce)';
  var videoObserver = null;

  function startVideo(video) {
    var src = video.getAttribute('data-sp-src');
    if (video.__spVideo || !src) return;
    video.__spVideo = true;
    var still = !!(window.matchMedia && window.matchMedia(STILL).matches);
    video.preload = still ? 'metadata' : 'auto';
    if (still) video.controls = true;
    video.muted = true; // el atributo ya está: la propiedad asegura el autoplay permitido (iOS, Chrome)
    video.src = src;
    try { video.load(); } catch (e) { /* nada */ }
    if (still) return;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () { video.controls = true; });
  }

  function initVideos(scope) {
    var list = toArray((scope && scope.querySelectorAll ? scope : document).querySelectorAll(LAZY_VIDEO)).filter(function (v) { return !v.__spVideo; });
    if (!list.length) return;
    if (!('IntersectionObserver' in window)) { list.forEach(startVideo); return; }
    if (!videoObserver) {
      videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          videoObserver.unobserve(en.target);
          startVideo(en.target);
        });
      }, { rootMargin: '200px 0px' });
    }
    list.forEach(function (v) { videoObserver.observe(v); });
  }

  // ---------------------------------------------------------------- inicio y editor de temas

  function init() {
    toArray(document.querySelectorAll('[data-sp-sticky]')).forEach(initSticky);
    initVideos(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
